import { IconContent } from '@icons';

export const padlockClosedFilled: IconContent = {
    sm: '<path fill-rule="evenodd" d="M6 5a2 2 0 1 1 4 0v2H6V5ZM5 7V5a3 3 0 0 1 6 0v2h2v7H3V7h2Zm2.5 4V9h1v2h-1Z" />',
    md: '<path fill-rule="evenodd" d="M9.5 7.5a2.5 2.5 0 0 1 5 0V11h-5V7.5Zm-1 3.5V7.5a3.5 3.5 0 1 1 7 0V11H19v9H5v-9h3.5Zm3 5v-3h1v3h-1Z" />',
};
